function stockTransferDataKey(){
  return 'stock-transfer-data'
}

function transferUniqueKey(codeId,branchId){
  return `${branchId}${codeId}`
}

function productCodeId() {
  return $('#selected-product-code option:selected').val()
}

function productCodeName() {
  return $('#selected-product-code option:selected').data('code-name')
}

function productId() {
  return $('#stock-transfer-form').data('product-id')
}

function addTransferStock() {
  $("#add-serial-batch").click(function () {

    const initiatorBranchId = $('#initiator-branch option:selected').val()
    const receiverBranchId = $('#receiver-branch option:selected').val()
    const initiatorBranchName = $('#initiator-branch option:selected').data('branch-name')
    const receiverBranchName = $('#receiver-branch option:selected').data('branch-name')
    const codeId = productCodeId()
    const codeName = productCodeName()
    const unitCostPrice = removeCommas($('#unit-cost-price').val());
    const quantity = getProductQuantity();
    const uniquekey = transferUniqueKey(codeId,initiatorBranchId)

    if ($("#" + uniquekey).length > 0) {
      toastNotification('error', `Product ${codeName} already added`);
    } else if(isNaN(quantity) || allWhiteSpaces(quantity)) {
      toastNotification('error', 'Quantity or Unit Cost is not valid');
    } else {

      const stockTransferItem = {
        key: uniquekey,
        code_name: codeName,
        code_id: codeId,
        quantity: quantity,
        initiator_id: initiatorBranchId,
        receiver_id: receiverBranchId,
        initiator_branch_name: initiatorBranchName,
        receiver_branch_name: receiverBranchName
      }

      storeItemInLocalStorage(stockTransferItem, stockTransferDataKey())
      setStockTransferDataRows()
    }
  });
}

function setInitialTransferData(view = 'edit', stockTransferIdAttr) {
  localStorage.removeItem(stockTransferDataKey())
  let stockTransferId = $('#stock-transfer-form input[name="stock_transfer[stock_transfer_id]"').val()

  if (view === 'index') {
    stockTransferId = stockTransferIdAttr
  }
  const action = $('#stock-transfer-form input[name="stock_transfer[transfer_action]"').val()

  if (view === 'edit' && (action === 'create' || stockTransferId === null || stockTransferId === undefined)) {
    return
  }

  $.ajax({
    type: "post",
    url: `/stock_transfer_details/${stockTransferId}`,
    headers: {
      'X-CSRF-Token': csrfToken()
    },
    dataType: "json",
    success: function (data) {
      console.log(data)
      localStorage.setItem(stockTransferDataKey(), JSON.stringify(data))
      setStockTransferDataRows()
    },
    error: function (data) {
      $('#stock-transfer-form input[name="commit"]').prop("disabled", false)
      console.log('An error occurred.');
      console.log(data);
    },
  });
}

function setStockTransferDataRows() {
  const stockTransferData = JSON.parse(localStorage.getItem(stockTransferDataKey()))

  if (stockTransferData === null || stockTransferData === undefined) {
    console.log('ERROR')
    return
  }

  // remove current content
  $(".stock-transfer-codes").empty()

  // set data rows
  $.each(stockTransferData, function (key, stockTransferDetails) {
    const initiatorBranchName = stockTransferDetails.initiator_branch_name
    const initiatorBranchId = stockTransferDetails.initiator_id
    const receiverBranchName = stockTransferDetails.receiver_branch_name
    const receiverBranchId = stockTransferDetails.receiver_id
    const codeName = stockTransferDetails.code_name
    const quantity = stockTransferDetails.quantity
    const codeId = stockTransferDetails.code_id
    const uniquekey = transferUniqueKey(codeId,initiatorBranchId)

    $(".stock-transfer-codes").append(
      `<tr id='${uniquekey}'>
        <td class="initiator-branch" data-branch-id="${initiatorBranchId}">${initiatorBranchName}</td>
        <td class="receiver-branch" data-branch-id="${receiverBranchId}">${receiverBranchName}</td>
        <td class="code-name" >${codeName}</td>
        <td class="quantity text-right">${numberWithCommas(quantity)}</td>
        <td>
          <a href='javascript:;' class='remove-stock-transfer-items' data-uniquekey='${uniquekey}'
          > 
            <i class='fa fa-minus-circle' style='font-size: 14px; margin-left: 15px; color: red'></i>
          </a>
        </td>
      </tr>`
    )
  })

  const totalQuantity = numberWithCommas(calculateStockTransferQuantity())

  // set total row
  $(".stock-transfer-codes").append(
    `<tr id='stock-transfer-total'>
      <td></td>
      <td></td>
      <td><strong>TOTAL</strong></td>
      <td class='total-quantity text-right'>${totalQuantity}</td>
      <td></td>
    </tr>`)

  $('input[name="stock_transfer[quantity]"]').val(totalQuantity)


  // setTotalAmount();
  $('#unit-cost-price').closest('.form-group').removeClass('has-success');
  $('#first-serial-number').val('')
  $('#last-serial-number').val('')
}

function calculateStockTransferQuantity() {
  const data = JSON.parse(localStorage.getItem(stockTransferDataKey()))

  if (data === null || data === undefined) {
    console.log('ERROR')
    return 0
  }

  let totalQuantity = Object.values(data).reduce(function (accumulator, curValue) {
    return accumulator + parseInt(curValue.quantity)
  }, 0)

  return totalQuantity
}

function removeStockTransferItems() {
  $("table").on('click', '.remove-stock-transfer-items', function () {
    const uniquekey = $(this).data('uniquekey');

    toastNotification('info', 'Removed Product');
    removeItemFromLocalStorage(uniquekey, stockTransferDataKey())
    $(this).closest("tr").remove();
    setStockTransferDataRows()
    $('#unit-cost-price').closest('.form-group').removeClass('has-success');

  });
}

function submitStockTransfer() {
  $('#submit-ajax-form-btn').click(function () {
    disableSubmit()

    let errorString = [];

    const dateOfTransfer = $('#stock-transfer-form input[name="stock_transfer[created_at]"]').val()
    const stockTransferData = JSON.parse(localStorage.getItem(stockTransferDataKey()))

    $('#stock-transfer-form input[name="commit"]').prop("disabled", false)

    if (JSON.stringify(stockTransferData) === '{}' || JSON.stringify(stockTransferData) === 'null') {
      errorString.push('No Serial Numbers detected, refresh and try again');
    }

    if (isEmpty(dateOfTransfer)) {
      errorString.push(' Transfer cannot be blank');
    }

    if (errorString.length > 0) {
      toastNotification('error', errorString.join(','))
    } else {
      $('#spinner-modal').modal('show');

      const postUrl = $('#stock-transfer-form').attr('action')
      const redirectUrl = '/stock_transfers'
      const description = $('#stock-transfer-form textarea[name="stock_transfer[description]"]').val()
      const initiatorBranchId = $('#initiator-branch option:selected').val()
      const receiverBranchId = $('#receiver-branch option:selected').val()


      let action = "post"

      if ($('#stock-transfer-form input[name="stock_transfer[transfer_action]"').val() === 'update') {
        action = "patch"
      }

      $.ajax({
        type: action,
        url: postUrl,
        headers: {
          'X-CSRF-Token': csrfToken()
        },
        data: {
          stock_transfer: {
            stock_transfer_data: stockTransferData,
            created_at: dateOfTransfer,
            description: description,
            initiator_id: initiatorBranchId,
            receiver_id: receiverBranchId
          }
        },
        dataType: "json",
        success: function (data) {

          window.location.replace(redirectUrl);
          console.log(data);
          localStorage.removeItem(stockTransferDataKey())

        },
        error: function (data) {
          disableSubmit()
          console.log('An error occurred.');
          console.log(data);
        },
      });
    }
  });
}


$(document).ready(function () {
  if ($('#stock-transfer-form').length > 0) {
    // checkAmount('.unit-cost-price', '.unit-cost-price-div');

    setInitialTransferData()
    // setStockQuantity('#selected-product-code')
    addTransferStock()
    removeStockTransferItems()
    submitStockTransfer()
    clearFailedSubmit('#stock-transfer-form')


    $('#selected-product-code').change(function () {
      // setStockQuantity('#selected-product-code')
    });
  }

  $('.view-stock-transfer-details').click(function () {
    const stockTransferId = $(this).data('stock-transfer-id')
    setInitialTransferData('index', stockTransferId)
  })
});
